import { z } from 'zod';

import { StoryFragment } from '../graphql/generated/graphql';
import { ValidationError } from '../utils/errors';

export type StoryBorder = 'solid' | 'none';

export const StorySchema = z
  .object({
    __typename: z.literal('Stories'),
    locale: z.string(),
    PreviewImage: z
      .any()
      .refine((value) => value !== undefined && value !== null, {
        message: 'Value must not be undefined or null',
      }),
    Slug: z.string(),
  })
  .passthrough();

export type Story = StoryFragment & z.infer<typeof StorySchema>;

export const isStory = (story: unknown, strict = true): story is Story => {
  const result = StorySchema.safeParse(story);
  if (strict && !result.success) {
    throw new ValidationError(
      `Invalid story: ${JSON.stringify(story)}` +
        '\n' +
        `Issues: ${JSON.stringify(result.error.issues)}`
    );
  }
  return result.success;
};
